<template>
  <div class="card col-lg-3 col-md-3 col-sm-6 col-xs-6">
    <router-link :to="store.route" v-if="store.active">
      <div class="card-wrap" :class="{'grey-card': (isPartnerGrey && !store.simple_card)}">
        <div class="no-underline parent-link">
          <div class="row parent center-xs pointer">
            <div class="services col-xs-12 flex center-xs" :class="{'hidden-cart' : store.code === 'all-discounts'}" >
              <div class="left-block-info-store col-md-6 col-xs-7 start-xs" v-if="store.code !== 'all-discounts'">
                <div class="info-store" v-if="store.schedule.time_from">
                  <div v-if="isTooEarly" class="left-info-block center-xs red-info">
                    <span class="material-icons">alarm</span>
                    {{ workHoursFrom }}
                  </div>
                  <div v-else class="left-info-block center-xs" :class="{'red-info': (isPartnerGrey && !store.simple_card)}">
                    <span class="material-icons">alarm</span>
                    {{ workHoursTo }}
                  </div>
                </div>
              </div>
              <div class="right-block-info-store col-xs-6 end-xs" v-if="hasDeliveryPrice && !store.simple_card && store.code !== 'all-discounts'">
                <span class="info-store" v-if="store.shipping !== undefined">
                  <div class="right-info-block center-xs inline-flex middle-xs">
                    <img class="scooter-icon" src="/assets/icons/icon-scooter.svg" alt="Scooter" width="64" height="64" loading="lazy" fetchpriority="auto">
                    {{ deliveryPrice }}
                  </div>
                </span>
              </div>
            </div>
            <div class="img-wrap col-xs-12 middle-xs flex">
              <img
                src="/assets/placeholder.svg"
                :alt="altText"
                :width="logoSize.width"
                :height="logoSize.height"
                loading="lazy"
                v-show="imageError"
              >
              <img
                ref="logo"
                :src="partnerLogo"
                :alt="altText"
                :width="logoSize.width"
                :height="logoSize.height"
                :decoding="lazy ? 'async' : 'sync'"
                :loading="lazy ? 'lazy' : 'eager'"
                :fetchpriority="lazy ? 'auto' : 'high'"
                @error="imageError = true"
                v-show="!imageError"
              >
            </div>
            <span class="col-xs-12 center-xs"> {{ store.about }}</span>
            <br />
          </div>
        </div>
      </div>
    </router-link>
    <div v-else class="card-wrap grey-card">
      <div class="no-underline parent-link">
        <div class="hidden-cart"></div>
        <div class="row parent center-xs">
          <div class="img-wrap col-xs-12 middle-xs flex">
            <img
              src="/assets/placeholder.svg"
              :alt="store.title"
              width="207"
              height="142"
              loading="lazy"
              v-show="imageError"
            />
            <img
              ref="logo"
              :src="partnerLogo"
              :alt="store.title"
              width="207"
              height="142"
              :decoding="lazy ? 'async' : 'sync'"
              :loading="lazy ? 'lazy' : 'eager'"
              :fetchpriority="lazy ? 'auto' : 'high'"
              @error="imageError = true"
              v-show="!imageError"
            />
          </div>
          <span class="col-xs-12 center-xs">{{ currentLocation.partners_coming_soon }}</span>
          <br />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { timezoneTime, s3Path, partnerWorkingTime } from "@vue-storefront/core/helpers";
import config from 'config';
import { hasProperties } from '@vue-storefront/core/helpers/workWithObjects';

export default {
  props: {
    store: {
      type: Object,
      required: true
    },
    lazy: {
      type: Boolean,
      required: true
    },
    seoContext: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      workingTime: {},
      imageError: false
    }
  },
  mounted () {
    const img = this.$refs.logo
    if (img && img.complete && img.naturalWidth === 0) this.imageError = true
  },
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      canShowFilterPartners: 'partners/canShowFilterPartners',
      isFilterOpened: 'partners/isFilterPartnerOpened',
      isOpened: 'partners/isPartnerOpened'
    }),
    logoSize () {
      return config.images.partner_card_logo
    },
    partnerLogo () {
      return s3Path(this.store.logo_path, config.images.partner_card_logo.width, config.images.partner_card_logo.height)
    },
    // Templated per K2-2985: "{restaurant} — {category} доставка {city}" when
    // shown on a category page; plain restaurant title otherwise (e.g. Home).
    altText () {
      if (!this.seoContext) {
        return this.store.title
      }
      return `${this.store.title} — ${this.seoContext.category} доставка ${this.seoContext.city}`
    },
    isPartnerOpened () {
      return this.canShowFilterPartners ? this.isFilterOpened(this.store.code) : this.isOpened(this.store.code)
    },
    isPartnerGrey () {
      return !this.isPartnerOpened || !this.store.active
    },
    isTooEarly () {
      this.workingTime = partnerWorkingTime(this.store)
      let now = timezoneTime()
      let timeFrom = new Date(now.getFullYear()
        + '/' + (now.getMonth() + 1)
        + '/' + now.getDate()
        + ' ' + this.workingTime.workFrom)

      return !this.isPartnerOpened && timeFrom > now
    },
    hasDeliveryPrice () {
      return hasProperties({ object: this.currentLocation, properties: ['base_delivery_price'] });
    },

    deliveryPrice () {
      if (this.hasDeliveryPrice) {
        return `${this.$t('from')} ${this.currentLocation.base_delivery_price} ${this.$t('UAH')}`
      }

      return ''
    },
    workFrom () {
      return this.workingTime.workFrom
    },
    workHoursFrom () {
      return this.workingTime.isWeekend ? this.$t('Closed') : `${this.$t('open from')} ${this.workingTime.workFrom.substring(0, 5)}`
    },
    workHoursTo () {
      return this.workingTime.isWeekend ? this.$t('Closed') : `${this.$t('to')} ${this.workingTime.workTo.substring(0, 5)}`
    }
  }
}
</script>
<style lang="scss" scoped>
  .card {
    padding-bottom: 16px;
    color: #333333;

    .card-wrap{
      position: relative;
      height: 100%;
      overflow: hidden;
      border-radius: 10px;
      background-color: #ffffff;
      box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, 0.06);
      &.grey-card{
        img {
          filter: grayscale(100%);
          opacity: 0.5;
        }
      }
    }
    .parent{
      padding-left: 15px;
      padding-right: 15px;
      padding-top: 0;
      position: relative;
      @media (max-width: 768px) {
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 0;

      }
    }
    .parent .img-wrap img{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-height: 100%;
      max-width: 100%;
      object-fit: contain;
    }
    .img-wrap{
      height: 0;
      padding-top: 55%;
      position: relative;
      display: block;
      margin-top: 10px;
    }
    .parent-link span{
      font-size: 18px;
      color: #333;
      margin-top: 15px;
      margin-bottom: 15px;
      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }
  .services {
    padding: 5px 0 8px 0;
  }
  .services {
    .left-block-info-store {
      max-height: 39px;
      padding-left: 0;
      padding-right: 6px;
      @media (max-width: 990px) and (min-width: 765px){
        padding-right: 0;
      }
      @media (max-width: 365px) {
        padding-right: 0;
      }
    }
    .right-block-info-store {
      max-height: 39px;
      padding-right: 0;
      padding-left: 3px;
    }
  }
  .info-store {
    .left-info-block {
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      background-color: #f9f8f6;
      padding: 5%;
      color: #11bb2e;
      font-size: 12px;
      @media (max-width: 990px) and (min-width: 765px){
        padding:10% 0;
      }
      @media (max-width: 765px) and (min-width: 425px){
        width: 90%;
        padding:5% 0;
      }
      @media (max-width: 425px) {
        width: 90%;
        padding:5% 0;
      }
      .material-icons {
        margin: 0;
        margin-bottom: 2px;
        padding-right: 4px;
        color: #11bb2e;
        font-size: 15px;
        @media (max-width: 990px) and (min-width: 765px){
          padding-right: 2px;
        }
        @media(max-width: 425px) {
          padding-right: 2px;
        }
      }
    }

    .red-info {
      color: red;
      .material-icons {
        color: red;
      }
    }

    .right-info-block {
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      background-color: #f9f8f6;
      padding: 3%;
      color: #11bb2e;
      font-size: 12px;
      @media (max-width: 425px) {
        padding:3% 0;
      }
      .scooter-icon {
        margin-right: 2px;
        height: 22px;
      }
    }
  }
  .hidden-cart{
    height: 52px;
  }
</style>
